import React, { useEffect } from "react";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import ControlButtons from "../ControlButtons/ControlButtons.jsx";
import Box from "@material-ui/core/Box";
import { useParams } from "react-router-dom";
import LoadingPaper from "../LoadingPaper/LoadingPaper.jsx";
import PropertiesList from "../PropertiesList/PropertiesList.jsx";
import RelationsList from "../RelationsList/RelationsList.jsx";

import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import PropTypes from "prop-types";

import { editButtonTheme as back } from "../../config/theme";
import { filterForView } from "../../lib/helperFuncs.jsx";

const ViewForm = (props) => {
    const MUTABLE = false;
    const { id } = useParams();
    useEffect(() => props.initAction(id), []);
    const {
        fields,
        item,
        relations,
        relationsDataSource,
        defaultPaymentTypes,
        defaultServices,
        serviceCategories,
        defaultValues,
        defaultRoomFeatures,
        unusedServicesHidden,
        defaultRates,
    } = { ...props };

    const buttons = [
        {
            type: back,
            icon: <ArrowBackIcon />,
            caption: "Вернуться",
            link: props.getBackLink(),
        },
    ];
    const layoutFields = filterForView(fields);

    if (props.item) {
        if (props.item.type !== "guest") {
            delete layoutFields.api_token;
        }
    }
    return !item || props.loading ? (
        <Paper elevation={3}>
            <LoadingPaper />
        </Paper>
    ) : (
        <Paper elevation={3}>
            <Box p={3}>
                <Typography mb={3} variant={"h5"}>
                    {`${props.title} ${props.item.name}`}
                </Typography>
            </Box>
            <Box mt={4}>
                {
                    <PropertiesList
                        relationsDataSource={relationsDataSource}
                        fields={layoutFields}
                        mutable={MUTABLE}
                        item={item}
                        defaultPaymentTypes={defaultPaymentTypes}
                        defaultServices={defaultServices}
                        serviceCategories={serviceCategories}
                        defaultValues={defaultValues}
                        defaultRoomFeatures={defaultRoomFeatures}
                        defaultRates={defaultRates}
                        unusedServicesHidden={unusedServicesHidden}
                    />
                }
            </Box>
            <Box mt={4}>
                {relations && (
                    <RelationsList
                        relations={relations}
                        relationsDataSource={relationsDataSource}
                        id={item.id}
                    />
                )}
            </Box>

            <Box pt={4} pb={4}>
                {<ControlButtons items={buttons} />}
            </Box>
        </Paper>
    );
};

ViewForm.defaultProps = {
    loading: true,
};

ViewForm.propTypes = {
    loading: PropTypes.bool.isRequired,
    fields: PropTypes.object,
    item: PropTypes.object,
    initAction: PropTypes.func.isRequired,
    relationsDataSource: PropTypes.func,
    getBackLink: PropTypes.func.isRequired,
    relations: PropTypes.object,
    title: PropTypes.string,
    getDefaultValues: PropTypes.func,
    defaultPaymentTypes: PropTypes.array,
    defaultServices: PropTypes.array,
    defaultValues: PropTypes.array,
    loadedPaymentTypes: PropTypes.bool,
    loadedServices: PropTypes.bool,
    unusedServicesHidden: PropTypes.object,
};

export default ViewForm;
